import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { keyBy, isEmpty, find } from 'lodash';
import CollectionCard from '../../components/widgets/CollectionCard';
import VerbHeading from '../../../shared/components/VerbHeading';
import LMSCard from '../../components/LMSCard';
import VerbText from '../../../shared/components/VerbText';
import log from '../../../shared/utils/log';
import NextPathwayMilestoneSection from './NextPathwayMilestoneSection';
import { RuntimeContext } from '../../../../common/RuntimeContext';

export default class RecommendedCollectionsSection extends Component {
    static propTypes = {
        associatedPathway: PropTypes.object,
        collection: PropTypes.object,
        collectionsById: PropTypes.object,
        collectionOptions: PropTypes.arrayOf(PropTypes.object),
        company: PropTypes.shape({
            customDiscover: PropTypes.object
        }),
        userCollection: PropTypes.object,
        loggedInUserCompany: PropTypes.object,
        handleClickPathway: PropTypes.func
    };

    static contextType = RuntimeContext;

    constructor(props) {
        super(props);
        this.state = {
            currentWidth: window.outerWidth,
            collectionsToRender: []
        };
    }
    resize = () => {
        if (window.outerWidth <= 768 || (this.state.currentWidth <= 768 && window.outerWidth >= 768)) {
            this.setState({
                currentWidth: window.outerWidth
            });
        }
    };

    componentDidMount() {
        window.addEventListener('resize', this.resize);
        this.setState({ collectionsToRender: this._getCollectionsToRender() });
    }
    
    componentWillUnmount() {
        window.removeEventListener('resize', this.resize);
        document.removeEventListener('keydown', this.escKeydownHandler, false);
    }

    _getCollectionsToRender = () => {
        const {
            collectionOptions,
            userCollection = {},
            company: { customDiscover = {} }
        } = this.props;

        if (!collectionOptions.length) {
            log.warn(
                `No collection recommendations. [UserCollection: ${JSON.stringify(
                    userCollection
                )}]`
            );
            return [];
        }
        const collectionsToRender = [];
        if(collectionOptions.length <= 2) {
            collectionsToRender.push(...collectionOptions);
        }else {
            const firstRandomCollection = this._getRandomInt(collectionOptions.length)
            collectionsToRender.push(collectionOptions[firstRandomCollection]);
            let nextRandomCollection = this._getRandomInt(collectionOptions.length);
            while(firstRandomCollection === nextRandomCollection) {
                nextRandomCollection = this._getRandomInt(collectionOptions.length);
            }
            collectionsToRender.push(collectionOptions[nextRandomCollection]);
        }
        return collectionsToRender;
    };

    _getRandomInt = (max) => {
        return Math.floor(Math.random() * max);
    }

    _makeCollectionCards = () => {
        const { currentWidth, collectionsToRender } = this.state;
        const imageProps = { dimension: { h: 160, w: 160 } };
        const isScreenSM = currentWidth <= 768;
        return (
            <div className={'collection-cards row continue-learning-row'}>
                {collectionsToRender.map((collection) =>
                    collection && collection._id ? (
                        <div
                            key={collection._id}
                            className={`collection-card-container ${isScreenSM ? 'col-12' : 'col-6'}`}
                            onClick={() => {}}
                        >
                            <CollectionCard
                                imageProps={imageProps}
                                collection={collection}
                                isReadOnly={false}
                                className={'recommended-collection-card'}
                                pathsContext={this.context.pathsWeb}
                                isCollInterstitial={true}
                                hideMetadata={true}
                                headerClassName={'continue-learning-collection-header'}
                            />
                        </div>
                    ) : null
                )}
            </div>
        );
    };

    _makeCollectionCardAndLMSCard = () => {
        const { loggedInUserCompany } = this.props;
        const { lmsIntegrations } = loggedInUserCompany;
        const { collectionsToRender } = this.state;
        const imageProps = { dimension: { h: 250, w: 250 } };
        const [collectionToRender] = collectionsToRender;
        return (
            <div className={'collection-cards'}>
                <div className={'row'}>
                    <div
                        key={collectionToRender._id}
                        className={'collection-card-container col-12 col-sm-6 col-md-6 '}
                        onClick={() => {}}
                    >
                        <CollectionCard
                            imageProps={imageProps}
                            collection={collectionToRender}
                            isReadOnly={false}
                            className={'recommended-collection-card col-12 col-sm-12 col-md-12'}
                            isCollInterstitial={true}
                            hideMetadata={true}
                        />
                    </div>
                    <LMSCard
                        className={'col-12 col-md-6'}
                        title={lmsIntegrations.lmsCard.title}
                        link={lmsIntegrations.lmsCard.link}
                        subtitle={lmsIntegrations.lmsCard.subtitle}
                        thumbnailImageUrl={lmsIntegrations.lmsCard.thumbnailImageUrl}
                    />
                </div>
            </div>
        );
    };

    render() {
        const {
            userCollection = {},
            collectionOptions = [],
            loggedInUserCompany,
            associatedPathway: { _id: currentPathwayId, name, content: pathwayContent = [] } = {},
            collectionsById,
            associatedPathway,
            handleClickPathway
        } = this.props;

        if (!collectionOptions || !collectionOptions.length) {
            return null;
        }

        const firstUncompletedMilestone = find(pathwayContent, (contentItem) => !contentItem.isCompleted);
        const id = (firstUncompletedMilestone && firstUncompletedMilestone.parentId) || '';
        let nextMilestone = id ? collectionsById[id] : {};
        if (firstUncompletedMilestone && firstUncompletedMilestone.dateTime) {
            nextMilestone = firstUncompletedMilestone;
        }

        return (
            <div className={'up-next-container'}>
                {associatedPathway && !isEmpty(nextMilestone) ? (
                    <NextPathwayMilestoneSection
                        nextMilestone={nextMilestone}
                        currentPathwayMilestones={pathwayContent}
                        currentPathwayId={currentPathwayId}
                        currentPathwayName={name}
                        handleClickPathway={handleClickPathway}
                    />
                ) : (
                    <div>
                        <VerbHeading
                            className={'section-heading'}
                            hNumber={2}
                            messageId={'CONTINUE_LEARNING_PROPER'}
                            defaultMessage={'CONTINUE LEARNING'}
                        />
                        {loggedInUserCompany.lmsIntegrations &&
                        loggedInUserCompany.lmsIntegrations.lmsCard &&
                        loggedInUserCompany.lmsIntegrations.lmsCard.link
                            ? this._makeCollectionCardAndLMSCard()
                            : this._makeCollectionCards()}
                    </div>
                )}
            </div>
        );
    }
}
